/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PtwRegistrationState } from './PtwRegistrationState';
import {
    instanceOfPtwRegistrationState,
    PtwRegistrationStateFromJSON,
    PtwRegistrationStateFromJSONTyped,
    PtwRegistrationStateToJSON,
} from './PtwRegistrationState';

/**
 * @type QaEquipmentCatalogDtoRegistrationState
 * 
 * @export
 */
export type QaEquipmentCatalogDtoRegistrationState = PtwRegistrationState;


export function QaEquipmentCatalogDtoRegistrationStateFromJSON(json: any): QaEquipmentCatalogDtoRegistrationState {
    return QaEquipmentCatalogDtoRegistrationStateFromJSONTyped(json, false);
}

export function QaEquipmentCatalogDtoRegistrationStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): QaEquipmentCatalogDtoRegistrationState {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...PtwRegistrationStateFromJSONTyped(json, true) };
    return  PtwRegistrationStateFromJSONTyped(json, true);
}

export function QaEquipmentCatalogDtoRegistrationStateToJSON(value?: QaEquipmentCatalogDtoRegistrationState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfPtwRegistrationState(value)) {
        return PtwRegistrationStateToJSON(value as PtwRegistrationState);
    }

    return {};
}

/**
 * Check if a given object implements the QaEquipmentCatalogDtoRegistrationState interface.
 */
export function instanceOfQaEquipmentCatalogDtoRegistrationState(value: any): value is QaEquipmentCatalogDtoRegistrationState {
    if (instanceOfPtwRegistrationState(value)) return true;
    return false;
}

